import * as React from 'react';
import * as Redux from 'react-redux';
import MUIDataTable from 'mui-datatables';
import {
  Box,
  Button,
  Grid,
  Tooltip,
  Typography,
  Stack,
  Card,
  CardContent,
  CardActions,
} from '@mui/material';
import styled from 'styled-components';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { LoadingWidget, ModalComponent } from '../../../../widgets';
import { Chip } from '@mui/material';
import { BLUE_COLOR } from '../../../../constants/ColorsConst';
import ActionsListWidget from '../../../../widgets/ActionsList';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import { grey } from '@mui/material/colors';

export const Links = styled.a`
  cursor: pointer;
  color: black;
  margin: 0px 0px;
  text-decoration: none;

  &:hover {
    color: blue;
  }
`;

const ListadoMateriasDocentes = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const docentesStore = Redux.useSelector((state) => state.docentes);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  const _handleEditClick = async (id) => {
    // const data = materiasStore.all.find((el) => el.id === id);
    // await setActivoMateriasAction(dispatch, data);
    // setOpenModalForm(true);
  };

  // const _handleDeleteClick = async (id) => {
  //   await deleteMateriasAction(
  //     dispatch,
  //     id,
  //     materiasStore.params,
  //     setLoadingDelete
  //   );
  //   setOpenModalDelete(false);
  // };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    // {
    //   name: CONST.link.name,
    //   label: CONST.link.label,
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return (
    //         <Links target="_blank" href={value}>
    //           {value}
    //         </Links>
    //       );
    //     },
    //   },
    // },
    // {
    //   name: CONST.referencia.name,
    //   label: CONST.referencia.label,
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return (
    //         <Links target="_blank" href={value}>
    //           {value}
    //         </Links>
    //       );
    //     },
    //   },
    // },
    {
      name: CONST.carreras.name,
      label: CONST.carreras.label,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value && value.length > 2) {
            return (
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Chip
                  size="small"
                  color="primary"
                  variant="outlined"
                  label={`${value[0].carrera.nombre} | ${value[0].modalidad}`}
                  sx={{ mr: 1 }}
                />
                <Chip size="small" label=" +2 " color="primary" />
              </Box>
            );
          }
          if (value && value.length >= 1) {
            return value.map((el, index) => (
              <Chip
                key={`listCar${index}`}
                size="small"
                color="primary"
                variant="outlined"
                label={`${el.carrera.nombre} | ${el.modalidad}`}
                sx={{ mr: 1 }}
              />
            ));
          }

          return <Chip size="small" label="N/A" />;
        },
      },
    },
    // {
    //   name: CONST.estatus.name,
    //   label: CONST.estatus.label,
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return (
    //         <Box sx={{ width: '70px' }}>
    //         <Tooltip
    //           describeChild
    //           title="Estatus del registro"
    //           placement="left"
    //         >
    //           <Chip
    //             label={value.nombre}
    //             size="small"
    //             color={value.id === 1 ? 'success' : 'error'}
    //           />
    //         </Tooltip>
    //         </Box>
    //       );
    //     },
    //   },
    // },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '70px' }}>
              <Stack direction="row">
                {/* <ActionsListWidget
                  id={tableMeta.rowData[0]}
                  onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                  onDelete={async () => {
                    const data = materiasStore.all.find(
                      (el) => el.id === tableMeta.rowData[0]
                    );
                    await setActivoMateriasAction(dispatch, data);
                    setOpenModalDelete(true);
                  }}
                /> */}
              </Stack>
            </Box>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  function getListado() {
    return docentesStore.activo.materias.map((el) => {
      return (
        <Grid item xs={12} md={12}>
          <Card
            sx={{
              p: 2,
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: grey[300],
              },
            }}
            onClick={() => {}}
          >
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              {el.nombre}
            </Typography>
            {/* <Typography sx={{ mb: 1.5 }} color="text.secondary">
            adjective
          </Typography>
          <Typography variant="body2">
            well meaning and kindly.
            <br />
            {'"a benevolent smile"'}
          </Typography> */}
          </Card>
        </Grid>
      );
    });
  }

  return (
    <Grid container spacing={1}>
      {/* <LoadingWidget
        isLoading={materiasStore.loadingAll || loadingDelete}
        text={loadingDelete ? 'Eliminando registro...' : 'Cargando lista...'}
      /> */}

      {docentesStore.activo?.materias?.length > 0 ? (
        getListado()
      ) : (
        <Typography variant="h6">No hay materias asignadas</Typography>
      )}
      {/* {materiasStore.activo ? (
        <ModalComponent
          id="modalDeleteMaterias"
          title={`Eliminar`}
          open={openModalDelete}
          maxWidth="sm"
          onClose={() => setOpenModalDelete(!openModalDelete)}
        >
          <Grid container spacing={1}>
            <Grid item md={12}>
              ¿Seguro que quieres eliminar esta materia?
              <Typography variant="h6">
                {materiasStore.activo.nombre}
              </Typography>
            </Grid>
            <Grid item md={12} align="right">
              <Button
                color="error"
                variant="outlined"
                onClick={async () => {
                  await _handleDeleteClick(materiasStore.activo.id);
                }}
                sx={{ mr: 2 }}
              >
                ELIMINAR
              </Button>
              <Button
                sx={{ color: BLUE_COLOR }}
                onClick={() => setOpenModalDelete(false)}
              >
                CANCELAR
              </Button>
            </Grid>
          </Grid>
        </ModalComponent>
      ) : null} */}
    </Grid>
  );
};

export default ListadoMateriasDocentes;
